import React from 'react';
import { View } from 'react-native';
import { getBuildNumber, getVersion } from 'react-native-device-info';
import styled from 'styled-components';

import dynamicSize from '@webtrader/core/dynamic-size';
import { useEASUpdateVersion } from '@webtrader/core/hooks/easUpdate/useEASUpdate';

import Text from '@/components/Text';

interface IVersionTextProps {}

const VersionText: FCC<IVersionTextProps> = () => {
  const { currentEASUpdateVersion } = useEASUpdateVersion();
  return (
    <StyleVersionTextContainer>
      <StyledText>
        V {`${getVersion()} ${currentEASUpdateVersion ? `(${currentEASUpdateVersion})` : ''} - ${getBuildNumber()} `}
      </StyledText>
    </StyleVersionTextContainer>
  );
};

export default VersionText;

const StyleVersionTextContainer = styled(View)`
  align-self: center;
  width: 100%;
  align-items: center;
  position: absolute;
  bottom: ${dynamicSize.convertSize(10)}px;
`;

const StyledText = styled(Text)`
  font-size: ${dynamicSize.convertSize(12)}px;
  color: ${({ theme }) => theme.colors.text[1]};
`;
